<template>
  <div class="w-full">
    <div
      data-testid="gamification-card-link"
      class="gamification-card"
      :class="isRewardClaimed || isRedeemable ? 'card-redeemable' : 'card-not-redeemable'"
    >
      <div class="icon-wrapper" :class="isRewardClaimed || isRedeemable ? 'bg-[#fff2e0]' : 'bg-[#F2F2F2]'" data-testid="icon-wrapper">
        <IcoGiftMinor :color="isRewardClaimed || isRedeemable ? '#FAB801' : '#8D8D8D'" class="flex" />
      </div>
      <div class="card-section">
        <BlTextAv variation="caption-12" color="secondary" data-testid="mission-index">Misi ke- {{ idx + 1 }}</BlTextAv>
        <BlTextAv
          variation="caption-12"
          :color="isRewardClaimed || isRedeemable ? 'primary' : 'subdued'"
          weight="bold"
          class="mt-4"
          data-testid="reward-value"
        >
          Saldo e-wallet {{ rewardValue | money }}
        </BlTextAv>
        <BlCapsuleAv
          v-if="!!redemptionStatus"
          :variation="redemptionStatus.variant"
          class="mt-4"
          size="small"
          data-testid="redemption-status"
        >
          {{ redemptionStatus.label }}
        </BlCapsuleAv>
        <BlTextAv
          v-else-if="isAvailableQuota"
          variation="caption-10"
          :color="isRedeemable ? 'primary' : 'subdued'"
          class="mt-4"
          data-testid="quota-value"
        >
          Kuota tersisa: {{ quotaValue }} pemenang
        </BlTextAv>
        <BlTextAv v-else variation="caption-10" color="error-01" class="mt-4" data-testid="quota-empty">Kuota pemenang habis</BlTextAv>
      </div>
      <div>
        <BlButtonAv
          v-if="isRedeemable && !redemptionStatus"
          class="btn-ambil"
          size="extra-small"
          data-testid="redeem-button"
          @click="onClickRedeem"
        >
          Ambil
        </BlButtonAv>
        <IcoLockMinor
          v-else-if="!isRedeemable && !isRewardClaimed"
          :color="isAvailableQuota ? '#EBEBEB' : '#B6B6B6'"
          data-testid="lock-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {IcoLockMinor, IcoGiftMinor} from '@bukalapak/bazaar-visual-next';
import {BlTextAv, BlButtonAv, BlCapsuleAv} from '@bukalapak/bazaar-mweb-latest';
import {money} from '@bukalapak/toolbox-helper/number-helper';

const REDEMPTION_STATUS_MAPPER = {
  pending: {
    label: 'Hadiah diproses ⏳',
    variant: 'informational',
  },
  processing: {
    label: 'Hadiah diproses ⏳',
    variant: 'informational',
  },
  failed: {
    label: 'Hadiah diproses ⏳',
    variant: 'informational',
  },
  rejected: {
    label: 'Penarikan gagal, silahkan hubungi bantuan',
    variant: 'critical',
  },
  success: {
    label: 'Sukses masuk e-wallet 🤑',
    variant: 'success',
  },
};

export default {
  name: 'GamificationCard',
  components: {
    BlTextAv,
    IcoLockMinor,
    IcoGiftMinor,
    BlButtonAv,
    BlCapsuleAv,
  },
  filters: {money},
  props: {
    mission: {
      type: Object,
      required: true,
    },
    idx: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isRewardClaimed() {
      return !!this.mission?.milestone?.reward_redemption;
    },
    isAvailableQuota() {
      return this.mission.used_quota < this.mission.quota;
    },
    isRedeemable() {
      return this.mission?.milestone?.state === 'completed' && this.isAvailableQuota;
    },
    rewardValue() {
      return this.mission?.reward || '';
    },
    quotaValue() {
      return this.mission?.quota ? this.mission.quota - (this.mission?.used_quota || 0) : '';
    },
    redemptionStatus() {
      if (!this.mission?.milestone?.reward_redemption) {
        return null;
      }

      return REDEMPTION_STATUS_MAPPER[this.mission?.milestone?.reward_redemption.status] || null;
    },
  },
  methods: {
    onClickRedeem() {
      this.$router.push({
        name: 'gamification-claim',
        params: {
          missionId: this.mission.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gamification-card {
  padding: 8px;
  border: 1px solid #d6d6d6;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  text-decoration: none;
}
.card-redeemable {
  border: 1px solid #fff2e0;
  background: linear-gradient(90deg, #ffffff 46.28%, #fff2e0 101.72%);
}
.card-not-redeemable {
  border: 1px solid #d6d6d6;
}
.card-section {
  width: 90%;
}
.icon-wrapper {
  padding: 7px;
  aspect-ratio: 1;
  clip-path: polygon(100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%, 25% 6.7%, 75% 6.7%);
}

.btn-ambil {
  background: #332f9e;
  border-radius: 100px;
  border: 2px solid #332f9e;
}
.btn-ambil:active {
  background: #4743c9;
  border-color: #4743c9;
}
.btn-ambil:hover {
  background: #4743c9;
  border-color: #4743c9;
}
</style>
